<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="error" rounded :block="isMobile()" v-on="on" v-bind="attrs" :small="!isMobile()" depressed
        >Cancelar solicitação</v-btn
      >
    </template>
    <v-card>
      <v-card-title>Cancelar solicitação</v-card-title>
      <v-card-text class="subtitle-1">
        Confirma o cancelamento da solicitação
        <b>{{ solicitacao.tipo_solicitacao }}</b> ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          text
          color="error"
          @click="cancelarSolicitacao()"
          :loading="cancelando"
          >Sim, cancelar</v-btn
        >
        <v-btn rounded text @click="dialog = false">Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  props: {
    solicitacao: Object,
  },
  data: () => ({
    dialog: false,
    cancelando: false,
  }),
  methods: {
    ...mapActions("planoSaude", ["getSolicitacoes"]),
    isMobile(){
      return this.$mq == 'sm'
    },
    async cancelarSolicitacao() {
      this.cancelando = true;
      await axios
        .post(
          "/colaborador/plano-saude/cancelar-solicitacao",
          JSON.stringify({
            id: this.solicitacao.codigo,
          })
        )
        .then(async (res) => {
          if (res.data.success) {
            this.$router.go()
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) => this.$toasted.error(e));      
      this.cancelando = false;
    },
  },
};
</script>

<style>
</style>